import React, { useEffect, useState } from 'react'
import { useIframeUrlMutation } from '../../app/services/DashBoard/adminDashBoardApi';

const CorporateMembershipReportView = () => {
    const [iframeUrl, setIframeUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [iframeUrlApi] = useIframeUrlMutation();

    const fetchIframeUrl = async () => {
        setLoading(true);
        setError("");

        try {
            const requestPayload = {
                QuestionId: 56,
                params: {},
                expMinutes: 0,
                bordered: false,
                titled: true,
            };
            const response = await iframeUrlApi(requestPayload).unwrap();
            setIframeUrl(response.iframeUrl);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch iframe URL");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIframeUrl();
    }, []);
    
    return (
        <div>
            <div style={{ padding: "20px", position: "relative" }}>
                <button
                    onClick={fetchIframeUrl}
                    class="btn success-btn reload-btn"
                    disabled={loading}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                >
                    {loading ? "Loading..." : "Reload Report"}
                </button>

                {loading && <p>Loading report...</p>}
                {error && <p style={{ color: "red" }}>{error}</p>}

                {iframeUrl && (
                    <div className="iframe-main-card">
                        <iframe
                            src={iframeUrl}
                            width="100%"
                            height="600"
                            frameBorder="0"
                            style={{ marginTop: "20px" }}
                            title="Metabase Report"
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default CorporateMembershipReportView 